<section class="profile-featured-area ptb-100">
    <div class="container">
        <div class="section-title" *ngIf="candidatoslenght != 0">
            <h2>Candidatos Destacados</h2>
        </div>

        <div class="profile-slides">
            <owl-carousel-o [options]="optionsSlides">
                <ng-template carouselSlide *ngFor="let candidato of candidatosDestacados">
                    <div class="profile-featured-item">
                        <img loading="lazy" [src]="candidato.imagen" alt="{{candidato.nombre+' '+candidato.apellidos}}" title="{{candidato.nombre+' '+candidato.apellidos}}"
                        [ngStyle]="{'width': getImagenWidth()}">

                        <div class="profile-featured-inner">
                            <h3>{{candidato.nombre + " "+ candidato.apellidos}}</h3>
                            <a (click)="seleccionarIdCandidato(candidato.idCandidato)">
                                Ver Perfil<i class="icofont-swoosh-right"></i>
                            </a>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </div>
</section>
